import loglevel, { LogLevelDesc } from "loglevel";

import config from "@/config";

const logger = loglevel.getLogger("torus-dashboard");
logger.setLevel(config.logLevel as LogLevelDesc);

export default logger;
